export const rowData = [
    {
        id: 1,
        firstname: "Erikson",
        lastname: "Steven",
        address: {
            city: "Baghdad",
            state: "Bahia",
            country: "Iraq",
            postelcode: "765436"
        }
    },
    {
        id: 2,
        firstname: "Fakes",
        lastname: "Dennis",
        address: {
            city: "Bahia Blanca",
            state: "Bandung",
            country: "Argentina",
            postelcode: "453256"
        }
    },
    {
        id: 3,
        firstname: "Cooley",
        lastname: "Mason",
        address: {
            city: "Balakovo",
            state: "Bangkok",
            country: "Azerbaijan",
            postelcode: "098765"
        }
    },
    {
        id: 4,
        firstname: "Braine",
        lastname: "John",
        address: {
            city: "Baliuag",
            state: "Banjul",
            country: "Thailand",
            postelcode: "543234"
        }
    },
    {
        id: 5,
        firstname: "Allais",
        lastname: "Alphonse",
        address: {
            city: "Turkey",
            state: "Batumi",
            country: "Georgia",
            postelcode: "345777"
        }
    },
    {
        id: 6,
        firstname: "Philip",
        lastname: "Edinburgh",
        address: {
            city: "Baghdad",
            state: "Bahia",
            country: "Iraq",
            postelcode: "765436"
        }
    },
    {
        id: 7,
        firstname: "Pinker",
        lastname: "Steven",
        address: {
            city: "Bahia Blanca",
            state: "Bandung",
            country: "Argentina",
            postelcode: "453256"
        }
    },
    {
        id: 8,
        firstname: "Qin Shi",
        lastname: "Huang",
        address: {
            city: "Balakovo",
            state: "Bangkok",
            country: "Azerbaijan",
            postelcode: "098765"
        }
    },
    {
        id: 9,
        firstname: "Theron",
        lastname: "Charlize",
        address: {
            city: "Baliuag",
            state: "Banjul",
            country: "Thailand",
            postelcode: "543234"
        }
    },
    {
        id: 10,
        firstname: "Spolsky",
        lastname: "Joel",
        address: {
            city: "Turkey",
            state: "Batumi",
            country: "Georgia",
            postelcode: "345777"
        }
    },
    {
        id: 11,
        firstname: "Palme",
        lastname: "Olof",
        address: {
            city: "Iraq",
            state: "Bandung",
            country: "Bahia",
            postelcode: "765436"
        }
    },
    {
        id: 12,
        firstname: "Pasteur",
        lastname: "Louis",
        address: {
            city: "Barnaul",
            state: "Bandung",
            country: "Russia",
            postelcode: "453256"
        }
    },
    {
        id: 13,
        firstname: "Reich",
        lastname: "Wilhelm",
        address: {
            city: "Baliuag",
            state: "Banjul",
            country: "Thiland",
            postelcode: "345333"
        }
    },
    {
        id: 14,
        firstname: "Braine",
        lastname: "John",
        address: {
            city: "Baliuag",
            state: "Bangkok",
            country: "Azerbaijan",
            postelcode: "45644"
        }
    },
    {
        id: 15,
        firstname: "Sagan",
        lastname: "Carl",
        address: {
            city: "Batumi",
            state: "Bahddd",
            country: "Georgia",
            postelcode: "346654"
        }
    },
    {
        id: 16,
        firstname: "Josip Broz",
        lastname: "Tito",
        address: {
            city: "Baghdad",
            state: "Bahia",
            country: "Iraq",
            postelcode: "765436"
        }
    },
    {
        id: 17,
        firstname: "Trotsky",
        lastname: "Leon",
        address: {
            city: "Bahia Blanca",
            state: "Argentina",
            country: "Baghdad",
            postelcode: "453256"
        }
    },
    {
        id: 18,
        firstname: "Jarmo",
        lastname: "Visakorpi",
        address: {
            city: "Balakovo",
            state: "Bangkok",
            country: "Azerbaijan",
            postelcode: "098765"
        }
    },
    {
        id: 19,
        firstname: "Theron",
        lastname: "Charlize",
        address: {
            city: "Baliuag",
            state: "Banjul",
            country: "Thailand",
            postelcode: "543234"
        }
    },
    {
        id: 20,
        firstname: "Wall",
        lastname: "Larry",
        address: {
            city: "Turkey",
            state: "Batumi",
            country: "Georgia",
            postelcode: "345777"
        }
    },
    {
        id: 21,
        firstname: "Erikson",
        lastname: "Steven",
        address: {
            city: "Baghdad",
            state: "Bahia",
            country: "Iraq",
            postelcode: "765436"
        }
    },
    {
        id: 22,
        firstname: "Fakes",
        lastname: "Dennis",
        address: {
            city: "Bahia Blanca",
            state: "Bandung",
            country: "Argentina",
            postelcode: "453256"
        }
    },
    {
        id: 23,
        firstname: "Cooley",
        lastname: "Mason",
        address: {
            city: "Balakovo",
            state: "Bangkok",
            country: "Azerbaijan",
            postelcode: "098765"
        }
    },
    {
        id: 24,
        firstname: "Braine",
        lastname: "John",
        address: {
            city: "Baliuag",
            state: "Banjul",
            country: "Thailand",
            postelcode: "543234"
        }
    },
    {
        id: 25,
        firstname: "Allais",
        lastname: "Alphonse",
        address: {
            city: "Turkey",
            state: "Batumi",
            country: "Georgia",
            postelcode: "345777"
        }
    },
    {
        id: 26,
        firstname: "Philip",
        lastname: "Edinburgh",
        address: {
            city: "Baghdad",
            state: "Bahia",
            country: "Iraq",
            postelcode: "765436"
        }
    },
    {
        id: 27,
        firstname: "Pinker",
        lastname: "Steven",
        address: {
            city: "Bahia Blanca",
            state: "Bandung",
            country: "Argentina",
            postelcode: "453256"
        }
    },
    {
        id: 28,
        firstname: "Qin Shi",
        lastname: "Huang",
        address: {
            city: "Balakovo",
            state: "Bangkok",
            country: "Azerbaijan",
            postelcode: "098765"
        }
    },
    {
        id: 29,
        firstname: "Theron",
        lastname: "Charlize",
        address: {
            city: "Baliuag",
            state: "Banjul",
            country: "Thailand",
            postelcode: "543234"
        }
    },
    {
        id: 30,
        firstname: "Spolsky",
        lastname: "Joel",
        address: {
            city: "Turkey",
            state: "Batumi",
            country: "Georgia",
            postelcode: "345777"
        }
    },
    {
        id: 31,
        firstname: "Wellstone",
        lastname: "Paul",
        address: {
            city: "Baghdad",
            state: "Bandung",
            country: "Iraq",
            postelcode: "436333"
        }
    },
    {
        id: 32,
        firstname: "Whitman",
        lastname: "Walt",
        address: {
            city: "Bahia Blanca",
            state: "ahia",
            country: "Argentina",
            postelcode: "568565"
        }
    },
    {
        id: 33,
        firstname: "Maney",
        lastname: "Panday",
        address: {
            city: "Uiusy",
            state: "Chgdyy",
            country: "Yusyyhh",
            postelcode: "098765"
        }
    },
    {
        id: 34,
        firstname: "Gurha",
        lastname: "Punhah",
        address: {
            city: "Baliuag",
            state: "Banjul",
            country: "Thailand",
            postelcode: "543234"
        }
    },
    {
        id: 35,
        firstname: "Xyshh",
        lastname: "Xoho",
        address: {
            city: "Turkey",
            state: "Batumi",
            country: "Georgia",
            postelcode: "345777"
        }
    },
    {
        id: 36,
        firstname: "Uyyy",
        lastname: "Kiduu",
        address: {
            city: "Baghdad",
            state: "Bahia",
            country: "Iraq",
            postelcode: "765436"
        }
    },
    {
        id: 37,
        firstname: "Yetahh",
        lastname: "isuuy",
        address: {
            city: "Bahia Blanca",
            state: "Bandung",
            country: "Argentina",
            postelcode: "453256"
        }
    },
    {
        id: 38,
        firstname: "Yhdh Shi",
        lastname: "Huang",
        address: {
            city: "Balakovo",
            state: "Bangkok",
            country: "Azerbaijan",
            postelcode: "098765"
        }
    },
    {
        id: 39,
        firstname: "Uhdh",
        lastname: "Charlize",
        address: {
            city: "Baliuag",
            state: "Banjul",
            country: "Thailand",
            postelcode: "543234"
        }
    },
    {
        id: 40,
        firstname: "Yshkks",
        lastname: "Joel",
        address: {
            city: "Turkey",
            state: "Batumi",
            country: "Georgia",
            postelcode: "345777"
        }
    },
    {
        id: 41,
        firstname: "Erikson",
        lastname: "Steven",
        address: {
            city: "Baghdad",
            state: "Bahia",
            country: "Iraq",
            postelcode: "765436"
        }
    },
    {
        id: 42,
        firstname: "Fakes",
        lastname: "Dennis",
        address: {
            city: "Bahia Blanca",
            state: "Bandung",
            country: "Argentina",
            postelcode: "453256"
        }
    },
    {
        id: 43,
        firstname: "Cooley",
        lastname: "Mason",
        address: {
            city: "Balakovo",
            state: "Bangkok",
            country: "Azerbaijan",
            postelcode: "098765"
        }
    },
    {
        id: 44,
        firstname: "Braine",
        lastname: "John",
        address: {
            city: "Baliuag",
            state: "Banjul",
            country: "Thailand",
            postelcode: "543234"
        }
    },
    {
        id: 45,
        firstname: "Allais",
        lastname: "Alphonse",
        address: {
            city: "Turkey",
            state: "Batumi",
            country: "Georgia",
            postelcode: "345777"
        }
    },
    {
        id: 46,
        firstname: "Philip",
        lastname: "Edinburgh",
        address: {
            city: "Baghdad",
            state: "Bahia",
            country: "Iraq",
            postelcode: "765436"
        }
    },
    {
        id: 47,
        firstname: "Pinker",
        lastname: "Steven",
        address: {
            city: "Bahia Blanca",
            state: "Bandung",
            country: "Argentina",
            postelcode: "453256"
        }
    },
    {
        id: 48,
        firstname: "Qin Shi",
        lastname: "Huang",
        address: {
            city: "Balakovo",
            state: "Bangkok",
            country: "Azerbaijan",
            postelcode: "098765"
        }
    },
    {
        id: 49,
        firstname: "Theron",
        lastname: "Charlize",
        address: {
            city: "Baliuag",
            state: "Banjul",
            country: "Thailand",
            postelcode: "543234"
        }
    },
    {
        id: 50,
        firstname: "Spolsky",
        lastname: "Joel",
        address: {
            city: "Turkey",
            state: "Batumi",
            country: "Georgia",
            postelcode: "345777"
        }
    }
];

export const dummyData = [
    {
        id: 1,
        key: 1,
        firstname: "Erikson",
        lastname: "Steven",
        isActive: true,
        phone_number: "2323234567",
        email: "roe@gmail.com"
    },
    {
        id: 2,
        key: 2,
        firstname: "Fakes",
        lastname: "Dennis",
        isActive: false,
        phone_number: "2323234567",
        email: "roe@gmail.com"
    },
    {
        id: 3,
        key: 3,
        firstname: "Cooley",
        lastname: "Mason",
        isActive: true,
        phone_number: "2323234567",
        email: "roe@gmail.com"
    },
    {
        id: 4,
        key: 4,
        firstname: "Braine",
        lastname: "John",
        isActive: true,
        phone_number: "2323234567",
        email: "roe@gmail.com"
    },
    {
        id: 5,
        key: 5,
        firstname: "Allais",
        lastname: "Alphonse",
        isActive: false,
        phone_number: "2323234567",
        email: "roe@gmail.com"
    },
    {
        id: 6,
        key: 6,
        firstname: "Philip",
        lastname: "Edinburgh",
        isActive: true,
        phone_number: "2323234567",
        email: "roe@gmail.com"
    },
    {
        id: 7,
        key: 7,
        firstname: "Pinker",
        lastname: "Steven",
        isActive: true,
        phone_number: "2323234567",
        email: "roe@gmail.com"
    },
    {
        id: 8,
        key: 8,
        firstname: "Qin Shi",
        lastname: "Huang",
        isActive: true,
        phone_number: "2323234567",
        email: "roe@gmail.com"
    },
    {
        id: 9,
        key: 9,
        firstname: "Theron",
        lastname: "Charlize",
        isActive: false,
        phone_number: "2323234567",
        email: "roe@gmail.com"
    },
    {
        id: 10,
        key: 10,
        firstname: "Spolsky",
        lastname: "Joel",
        isActive: true,
        phone_number: "2323234567",
        email: "roe@gmail.com"
    }
]